import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import PropTypes from 'prop-types';
import { cn } from '../../../common-utils/libraries/tailwind/utils';
import Icon from '../renders/icon/Icon';
import ICONS from '../../enums/icons';
import { Separator } from './separator';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cn('mb-4 shadow-md', className)} {...props} />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef(({ className, children, open, ...props }, ref) => (
  <AccordionPrimitive.Header className={`flex bg-white rounded-t-md ${!open && ' rounded-b-md'}`}>
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'flex flex-1 items-center justify-between px-2 py-2 font-medium transition-all',
        'outline-none focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 [&[data-state=open]>svg]:rotate-180',
        className
      )}
      {...props}>
      {children}
      <Icon icon={ICONS.CHEVRON_DOWN} className={`shrink-0 transition-transform duration-200 ${open && 'rotate-180'}`} />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className='overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down rounded-b-md bg-white'
    {...props}>
    <div className='px-2 sm:px-6 lg:px-8'>
      <Separator />
    </div>
    <div className={cn('py-4 pl-2 pr-3 sm:pl-4 sm:pr-6 lg:px-8', className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

AccordionItem.propTypes = {
  className: PropTypes.string
};

AccordionTrigger.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  open: PropTypes.bool
};

AccordionContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
